module.exports = __webpack_public_path__ + "assets/bb4b06a1617fb6e936e7e4aa8d620978.mp4";